import { isAfter } from 'date-fns';

interface Props {
  dateToCompare?: Date | string | null;
  dateToCompareTo?: Date | string | null;
}

/**
 * Determines if one date is after another.
 * Note: returns `false` if dates are equal
 * @returns boolean
 */
export const dateIsAfter = ({ dateToCompare, dateToCompareTo }: Props) => {
  if (!dateToCompare || !dateToCompareTo) {
    return false;
  }

  return isAfter(new Date(dateToCompare), new Date(dateToCompareTo));
};
